var map = {
	"./404/robot-lg.png": "Jlcy",
	"./404/robot-xs.png": "bzZ/",
	"./about-us/founders/aboutus-ed-desktop.jpg": "eoR0",
	"./about-us/founders/aboutus-ed.jpg": "y37v",
	"./about-us/founders/cristina-desktop.jpg": "yQb+",
	"./about-us/founders/cristina-mobile.jpg": "94e8",
	"./about-us/founders/david-desktop.jpg": "0mbC",
	"./about-us/founders/david-mobile.jpg": "2EVe",
	"./about-us/gallery/sanpablo-1-desktop.jpg": "oYRQ",
	"./about-us/gallery/sanpablo-1.jpg": "U3ub",
	"./about-us/gallery/sanpablo-2-desktop.jpg": "mM7U",
	"./about-us/gallery/sanpablo-2.jpg": "rVyg",
	"./about-us/gallery/sanpablo-3-desktop.jpg": "mB9J",
	"./about-us/gallery/sanpablo-3.jpg": "w5t/",
	"./about-us/gallery/sanpablo-4-desktop.jpg": "t+Mf",
	"./about-us/gallery/sanpablo-4.jpg": "PZLo",
	"./about-us/gallery/sanpablo-5-desktop.jpg": "Il1s",
	"./about-us/gallery/sanpablo-5.jpg": "Gdmz",
	"./about-us/hero/about-us-hero-desktop.jpg": "2G+M",
	"./about-us/hero/about-us-hero.jpg": "1BUf",
	"./about-us/hiring/aboutus-hiring-desktop.jpg": "p5St",
	"./about-us/hiring/aboutus-hiring.jpg": "bpmT",
	"./about-us/investors/dst.png": "Sozi",
	"./about-us/investors/foundersfund.png": "CiaX",
	"./about-us/investors/kaszek.png": "rm5f",
	"./about-us/investors/qed.png": "+JC6",
	"./about-us/investors/sequoia.png": "NrCi",
	"./about-us/investors/tcv.png": "ImJN",
	"./about-us/investors/tencent.png": "W9bT",
	"./about-us/investors/tiger.png": "fyV4",
	"./about-us/prizes/fastcompany.png": "CJeu",
	"./about-us/prizes/forbes.png": "GeQs",
	"./about-us/prizes/kpmg.png": "jxQr",
	"./about-us/testimonials/aboutus-xpeer-desktop.jpg": "5SuH",
	"./about-us/testimonials/aboutus-xpeer.jpg": "mdTZ",
	"./cdt/cdt-vs-cajitas/cajita-con-cdt-nu.png": "knrz",
	"./cdt/cdt-vs-cajitas/cajita-nu.png": "AfJL",
	"./cdt/decorative-section/bars-lg.jpg": "cLVF",
	"./cdt/decorative-section/bars-md.jpg": "a+Mn",
	"./cdt/decorative-section/bars-xs.jpg": "/Zqo",
	"./cdt/hero/hero-lg.jpg": "Ub9T",
	"./cdt/hero/hero-md.jpg": "G95X",
	"./cdt/hero/hero-xs.jpg": "fu9T",
	"./cdt/mechanics/choose-maturity-period.png": "/IZy",
	"./cdt/mechanics/choose-money-box.gif": "4nC8",
	"./cdt/mechanics/choose-money-box.png": "nTdm",
	"./cdt/mechanics/define-investment.png": "F99O",
	"./cdt/mechanics/get-earnings.gif": "GwvS",
	"./cdt/mechanics/get-earnings.png": "hQ82",
	"./cdt/mechanics/look-earnings.png": "nW17",
	"./credit-card/hero/credit-card-hero-lg-1x.jpg": "sCD8",
	"./credit-card/hero/credit-card-hero-md-1x.jpg": "0xvW",
	"./credit-card/hero/credit-card-hero-xs-1x.jpg": "C1fv",
	"./credit-card/pay/animated-logo.gif": "oqkj",
	"./credit-card/pay/apple-pay-mini.png": "ty7C",
	"./credit-card/pay/apple-pay.png": "MXWi",
	"./credit-card/pay/google-pay.png": "ywyh",
	"./credit-card/pay/google-wallet-mini.png": "PfSV",
	"./credit-card/product-information/app-avatar-4x.png": "5njA",
	"./credit-card/product-information/document-avatar-4x.png": "C6Re",
	"./credit-card/product-information/product-information-lg-1x.jpg": "BgMz",
	"./credit-card/product-information/product-information-md-1x.jpg": "y0IT",
	"./credit-card/product-information/product-information-xs-1x.jpg": "ucxr",
	"./credit-card/promise/adjust-credit-limit.gif": "0dMu",
	"./credit-card/promise/cash-advances.gif": "3T9p",
	"./credit-card/promise/instalments-change.gif": "4PT1",
	"./credit-card/seo/website-thumb-large.jpg": "FFy7",
	"./credit-card/seo/website-thumb.jpg": "o0BV",
	"./credit-card/value-proposal/value-proposal-lg-2x.png": "AU7m",
	"./credit-card/value-proposal/value-proposal-md-2x.png": "f19z",
	"./credit-card/value-proposal/value-proposal-xs-2x.png": "bSM7",
	"./credit-card/value-proposal/value-proposal.gif": "VJzz",
	"./email-verification/email-verification-loading.png": "u3tZ",
	"./email-verification/email-verification-success.jpg": "/IdL",
	"./ethic-and-compliance/aml/Nubank_HickDuarte_59058 1_lg.png": "ZXFp",
	"./ethic-and-compliance/aml/Nubank_HickDuarte_59058 1_md.png": "LC6S",
	"./ethic-and-compliance/aml/Nubank_HickDuarte_59058 1_xs.png": "8YZ8",
	"./ethic-and-compliance/code-of-conduct/Nubank_HickDuarte_55193_lg.jpg": "dUwI",
	"./ethic-and-compliance/code-of-conduct/Nubank_HickDuarte_55193_md.jpg": "bF2W",
	"./ethic-and-compliance/code-of-conduct/Nubank_HickDuarte_55193_xs.jpg": "S9Ob",
	"./ethic-and-compliance/compliance-policy/Nubank_HickDuarte_58741_lg.jpg": "23Oc",
	"./ethic-and-compliance/compliance-policy/Nubank_HickDuarte_58741_md.jpg": "iLAc",
	"./ethic-and-compliance/compliance-policy/Nubank_HickDuarte_58741_xs.jpg": "6t18",
	"./ethic-and-compliance/header/Nubank_HickDuarte_57380_lg.png": "2lq5",
	"./ethic-and-compliance/header/Nubank_HickDuarte_57380_md.png": "mKRY",
	"./ethic-and-compliance/header/Nubank_HickDuarte_57380_xs.png": "lflS",
	"./ethic-and-compliance/info-parker/NU_ComplianceTeam_ParkerLogo-08 1_lg.png": "u4cd",
	"./ethic-and-compliance/info-parker/NU_ComplianceTeam_ParkerLogo-08 1_md.png": "qa05",
	"./ethic-and-compliance/info-parker/NU_ComplianceTeam_ParkerLogo-08 1_xs.png": "LTdo",
	"./ethic-and-compliance/mission/Nubank_HickDuarte_54700_lg.jpg": "eRd7",
	"./ethic-and-compliance/mission/Nubank_HickDuarte_54700_md.jpg": "KHfF",
	"./ethic-and-compliance/mission/Nubank_HickDuarte_54700_xs.jpg": "Iqc/",
	"./ethic-and-compliance/procedure/Protect yourself_lg.png": "5eUY",
	"./ethic-and-compliance/procedure/Protect yourself_md.png": "6ZXD",
	"./ethic-and-compliance/supplier-code-of-conduct/Nubank_HickDuarte_58654 (2) 1_lg.jpg": "5d2u",
	"./ethic-and-compliance/supplier-code-of-conduct/Nubank_HickDuarte_58654 (2) 1_md.jpg": "TkzP",
	"./ethic-and-compliance/supplier-code-of-conduct/Nubank_HickDuarte_58654 (2) 1_xs.jpg": "B+l2",
	"./home/banner/savingsbanner-lg-2x.jpg": "jy7Q",
	"./home/banner/savingsbanner-md-1-5x.jpg": "1jLb",
	"./home/banner/savingsbanner-xs-1x.jpg": "HAoR",
	"./home/blog/blog-075x.jpg": "+9Zo",
	"./home/blog/blog-15x.jpg": "zDJf",
	"./home/blog/blog-1x.jpg": "4HcW",
	"./home/hero/hero-100m-desktop.jpg": "RWZ7",
	"./home/hero/hero-100m-mobile.jpg": "K6Md",
	"./home/hero/hero-100m-tablet.jpg": "PJwZ",
	"./home/hero/hero-desktop-large-v1.jpg": "Bsx8",
	"./home/hero/hero-desktop-v1.jpg": "S/uq",
	"./home/hero/hero-mobile-v1.jpg": "jitW",
	"./home/perks/perks-075x.jpg": "DrUR",
	"./home/perks/perks-15x.jpg": "cslk",
	"./home/perks/perks-1x.jpg": "lbFo",
	"./mgm/mgm-lg-2.png": "ceKK",
	"./mgm/mgm-lg-2x-v2.jpg": "89C1",
	"./mgm/mgm-lg-2x.jpg": "Syg1",
	"./mgm/mgm-md-2.png": "3E7g",
	"./mgm/mgm-md-2x.jpg": "VAe4",
	"./mgm/mgm-xs-2.png": "PJii",
	"./mgm/mgm-xs-2x.jpg": "HLin",
	"./mgm/ticket-01-01.png": "0R9d",
	"./mgm/ticket-01-02.png": "RGn8",
	"./mgm/ticket-01-03.png": "Ow5M",
	"./mgm/ticket-02-01.png": "k0Bc",
	"./mgm/ticket-02-02.png": "wftI",
	"./mgm/ticket-02-03.png": "rMXN",
	"./multi-product-home/blog/blog-lg-1x.jpg": "YHF8",
	"./multi-product-home/blog/blog-xs-1x.jpg": "kMR6",
	"./multi-product-home/contract/contract.png": "0/NM",
	"./multi-product-home/footer/footer-fogafin-4x.png": "kMXr",
	"./multi-product-home/footer/footer-fogafin-cucuta-4x.png": "YMkK",
	"./multi-product-home/footer/footer-sic-4x.png": "yN6v",
	"./multi-product-home/footer/footer-superfinanciera-4x.png": "kx8q",
	"./multi-product-home/footer/logos-compliance.png": "O3rg",
	"./multi-product-home/hero/hero-cultural-hack-xs-2x.jpg": "O6ld",
	"./multi-product-home/hero/hero-lg-1x.jpg": "QqaE",
	"./multi-product-home/hero/hero-md-1x.jpg": "oVSm",
	"./multi-product-home/hero/hero-xs-1x.jpg": "+uoU",
	"./multi-product-home/perks/cucuta-perks-lg-1x.jpg": "QRnI",
	"./multi-product-home/perks/cucuta-perks-md-1x.jpg": "m5VF",
	"./multi-product-home/perks/cucuta-perks-xs-2x.jpg": "5X1Q",
	"./multi-product-home/perks/perks-lg-2x.jpg": "/hT0",
	"./multi-product-home/perks/perks-md-2x.jpg": "bkHA",
	"./multi-product-home/perks/perks-xs-2x.jpg": "+TlZ",
	"./multi-product-home/products/credits/creditsprd-lg.jpg": "Qqpm",
	"./multi-product-home/products/credits/creditsprd-md.jpg": "MvfU",
	"./multi-product-home/products/credits/creditsprd-xs.jpg": "Jk4E",
	"./multi-product-home/products/credits/perks/credit-card-perks-lg-1x.png": "96m8",
	"./multi-product-home/products/credits/perks/credit-card-perks-md-1x.png": "rlAG",
	"./multi-product-home/products/credits/perks/credit-card-perks-xs-1x.gif": "lA/h",
	"./multi-product-home/products/credits/perks/credit-card-perks-xs-1x.png": "57GT",
	"./multi-product-home/products/savings/fogafin.png": "67PR",
	"./multi-product-home/products/savings/perks/savings-perks.gif": "Vosz",
	"./multi-product-home/products/savings/savings-lg.jpg": "Zw8e",
	"./multi-product-home/products/savings/savings-md.jpg": "nB1m",
	"./multi-product-home/products/savings/savings-without-logos-lg-2x.jpg": "h4eM",
	"./multi-product-home/products/savings/savings-without-logos-md-2x.jpg": "S/JN",
	"./multi-product-home/products/savings/savings-without-logos-xs-2x.jpg": "85kL",
	"./multi-product-home/products/savings/savings-xs.jpg": "boF8",
	"./multi-product-home/products/savings/vigilado-superfn.png": "pSyd",
	"./password/celebrate.jpg": "E++G",
	"./press/hero/press-hero-desktop.jpg": "JFSP",
	"./press/hero/press-hero.jpg": "1v1z",
	"./press/media/medium-fastcompany.png": "nCOC",
	"./press/media/medium-nyt.png": "EpVv",
	"./press/media/medium-reuters.png": "3gzX",
	"./press/media/medium-techcrunch.png": "HHfO",
	"./press/media/press-media-desktop.jpg": "8r2c",
	"./press/media/press-media.jpg": "5/pv",
	"./pse-payment-authorization/desktop-lg.jpg": "hkta",
	"./pse-payment-authorization/pse-payment-desktop-lg.jpg": "XZwI",
	"./registration/cardHasArrivedDebit.svg": "qctn",
	"./registration/cardMoradita.svg": "66bl",
	"./registration/floatingCard.svg": "yX/x",
	"./registration/handEmail.svg": "LO8y",
	"./registration/highFive.svg": "W03b",
	"./registration/improving.svg": "TgYl",
	"./registration/merchant.svg": "V+cj",
	"./registration/nuis_light_heart.svg": "OXGP",
	"./registration/openAppQrCode.jpg": "/lhM",
	"./registration/openBankingConfirmation.svg": "Fqu6",
	"./registration/savingsPlant.svg": "E+w3",
	"./registration/wellDone.svg": "LP5D",
	"./registration/wellDoneHiFive.svg": "RoPz",
	"./savings-waitlist/blog/blog1-lg.png": "yHJW",
	"./savings-waitlist/blog/blog1-xs.png": "IQ6z",
	"./savings-waitlist/blog/blog2-lg.png": "g8xt",
	"./savings-waitlist/blog/blog2-xs.png": "2hAj",
	"./savings-waitlist/blog/blog3-lg.png": "Ki7F",
	"./savings-waitlist/blog/blog3-xs.png": "ozxp",
	"./savings-waitlist/blog/blog3a-lg.jpg": "8D6D",
	"./savings-waitlist/blog/blog3a-xs.jpg": "kAwJ",
	"./savings-waitlist/hero/hero-lg.jpg": "YZDb",
	"./savings-waitlist/hero/hero-md.jpg": "k7QN",
	"./savings-waitlist/hero/hero-xs.jpg": "y0Cf",
	"./savings-waitlist/promise/savings-waitlist-promise-1a-lg-2x.jpg": "EX3V",
	"./savings-waitlist/promise/savings-waitlist-promise-1a-xs-1x.jpg": "RSVn",
	"./savings-waitlist/promise/savings-waitlist-promise-1b-lg-1x.jpg": "C4fR",
	"./savings-waitlist/promise/savings-waitlist-promise-3b-lg-1x.jpg": "d3of",
	"./savings-waitlist/promise/savings-waitlist-promise-3b-lg-2x.jpg": "HXw2",
	"./savings-waitlist/promise/savings-waitlist-promise-3b-xs-1x.jpg": "DG4R",
	"./savings-waitlist/value-proposal/cuenta.png": "cfGr",
	"./savings/blog/blog3a-lg.jpg": "NbtC",
	"./savings/blog/blog3a-xs.jpg": "o3nO",
	"./savings/blog/blog4-lg.png": "eHtu",
	"./savings/blog/blog4-xs.png": "gPsC",
	"./savings/blog/cajita-lg.png": "g8yX",
	"./savings/blog/cajita-xs.png": "WOoL",
	"./savings/blog/instant-pay-xs.png": "AUOv",
	"./savings/blog/instant-pay.jpg": "KCaw",
	"./savings/blog/sarlaft-lg.png": "z8vy",
	"./savings/blog/sarlaft-xs.png": "P1/R",
	"./savings/hero/savings-hero-lg.jpg": "EnXx",
	"./savings/hero/savings-hero-md.jpg": "81Lj",
	"./savings/hero/savings-hero-xs.jpg": "DyaR",
	"./savings/pay/apple-pay-mini.png": "JQ9z",
	"./savings/pay/apple-pay.png": "jtO+",
	"./savings/pay/google-pay.png": "e/Q0",
	"./savings/pay/google-wallet-mini.png": "kTPt",
	"./savings/placa/WhatIsNuPlaca.png": "KG9a",
	"./savings/placa/WhereCanISeeIt.png": "TevL",
	"./savings/product-information/add-person-avatar-4x.png": "qNoM",
	"./savings/product-information/app-avatar-4x.png": "2Uzn",
	"./savings/product-information/product-information-lg-1x.jpg": "jAwM",
	"./savings/product-information/product-information-md-1x.jpg": "GAG1",
	"./savings/product-information/product-information-xs-1x.jpg": "c4+5",
	"./savings/promise/NoManagementFee.png": "NNws",
	"./savings/promise/NoTransferFee.png": "ssuP",
	"./savings/promise/YourMoneyIsGrowing.png": "qsH9",
	"./savings/promise/iPhone12pro_1.png": "OYso",
	"./savings/promise/iPhone12pro_2.png": "ei/R",
	"./savings/promise/iPhone12pro_3.png": "gpd/",
	"./savings/seo/website-thumb-large.jpg": "GtzR",
	"./savings/seo/website-thumb.jpg": "xUUf",
	"./savings/value-proposal.png": "JLmY",
	"./savings/value_proposal_lg.png": "QXs4",
	"./savings/value_proposal_md.png": "zoic",
	"./savings/value_proposal_xs.png": "v4Le",
	"./savings/vigilado-left.png": "UDOW",
	"./savings/vigilado-xl.png": "Oo4y",
	"./savings/vigilado.png": "aSy0",
	"./secured-card/for-who/for-who-md.jpg": "v7I6",
	"./secured-card/for-who/for-who-xs.jpg": "sVjj",
	"./secured-card/hero/hero-lg.jpg": "71T4",
	"./secured-card/hero/hero-md.jpg": "D21I",
	"./secured-card/hero/hero-xs.jpg": "i4fi",
	"./secured-card/history-path/card.png": "yqzo",
	"./secured-card/history-path/missions.png": "kztf",
	"./secured-card/history-path/payed.png": "kfoO",
	"./secured-card/history-path/sec.gif": "liw5",
	"./seo/mgm/mgm-invite-ticket-1.jpg": "keoW",
	"./seo/mgm/mgm-invite-ticket-2.jpg": "9vTE",
	"./seo/mgm/mgm-invite-ticket-3.jpg": "v+dd",
	"./seo/mgm/mgm-invite-ticket-4.jpg": "BLvn",
	"./seo/mgm/mgm-invite-ticket-5.jpg": "3Wib",
	"./seo/mgm/mgm-invite-ticket-6.jpg": "gkpu",
	"./seo/open-graph-experiment-large.jpg": "H6Z/",
	"./seo/open-graph-experiment.jpg": "adlz",
	"./seo/open-graph-large.jpg": "5aAI",
	"./seo/open-graph.jpg": "h0p/",
	"./seo/website-mgm-thumb-large.jpg": "LPSI",
	"./seo/website-thumb-large.jpg": "p780",
	"./seo/website-thumb.jpg": "z3k+",
	"./world-cup/benefits/cart-outline.svg": "cLk0",
	"./world-cup/benefits/smartphone.svg": "lUPi",
	"./world-cup/benefits/withdrawal.svg": "JFlM",
	"./world-cup/credit-card/nuapp@1x.png": "fisY",
	"./world-cup/credit-card/nuapp@2x.png": "7xB0",
	"./world-cup/credit-card/nuapp@3x.png": "FdyI",
	"./world-cup/fifa/fifa-logo.svg": "ZNgu",
	"./world-cup/fifa/nu-fifa-logo@2x.png": "sz8N",
	"./world-cup/fifa/nu-fifa-logo@3x.png": "fkPq",
	"./world-cup/finance/phone@1x.png": "qrA6",
	"./world-cup/finance/phone@2x.png": "SxST",
	"./world-cup/finance/phone@3x.png": "m/62",
	"./world-cup/hero/ana_1@3x.png": "0O/x",
	"./world-cup/hero/background@1x.png": "GO+p",
	"./world-cup/hero/background@2x.png": "0gV3",
	"./world-cup/hero/background@3x.png": "OpGx",
	"./world-cup/hero/diana_1@3x.png": "P0EZ",
	"./world-cup/hero/jorge_1@3x.png": "T0ZX",
	"./world-cup/hero/mateo_1@3x.png": "+XIZ",
	"./world-cup/hero/players@3x.png": "zZni",
	"./world-cup/hero/rec-group-white.svg": "qx+h",
	"./world-cup/hero/rec-group.svg": "xVPZ",
	"./world-cup/hero/worldcup-lg-2x.jpg": "HgPw",
	"./world-cup/hero/worldcup-md-2x.jpg": "f5V7",
	"./world-cup/hero/worldcup-xs-2x.jpg": "1cCj",
	"./world-cup/invite/join-us-md-3x.png": "MqHG",
	"./world-cup/invite/join-us-xs-1x.png": "8AMx",
	"./world-cup/invite/join-us-xs-2x.png": "SdVK",
	"./world-cup/invite/word-cup-lg-3x.png": "7Vgz",
	"./world-cup/invite/word-cup-md-3x.png": "Wwsu",
	"./world-cup/invite/word-cup-xs-1x.png": "fO+T",
	"./world-cup/signup/hick@1x.png": "2hLs",
	"./world-cup/signup/hick@2x.png": "vJle",
	"./world-cup/signup/hick@3x.png": "X4jj"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "F6xd";